import { State } from '@/store/store'
export interface List {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: any[]
}

export class ThisState {
  public list: List
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export default ThisState
